export default {"src":"/_next/static/media/OrbIngidgoMedium.68a02740.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};